import { useEffect, useState } from "react";
import axios from "axios";
import { shortDate } from "@/lib/format";
import { Logo } from "@/components/Logo";
import { Card } from "@/components/ui/card";
import { Loader2, Megaphone, Clock, Repeat } from "lucide-react";

export default function TodayPublic() {
  const [data, setData] = useState(null);
  useEffect(() => {
    const load = () => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/today`).then((r) => setData(r.data));
    load(); const t = setInterval(load, 5 * 60 * 1000); return () => clearInterval(t);
  }, []);
  if (!data) return <div className="min-h-screen flex items-center justify-center bg-amber-50"><Loader2 className="w-8 h-8 animate-spin text-orange-500" /></div>;
  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-amber-50" data-testid="today-public">
      <div className="max-w-2xl mx-auto px-4 py-8 space-y-6">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <Logo size="md" />
          <div className="text-right"><div className="text-xs text-orange-500 font-semibold uppercase tracking-wider">Jadwal Les Hari Ini</div><div className="font-display text-2xl font-bold text-slate-900" data-testid="today-date">{data.day}, {shortDate(data.date)}</div></div>
        </div>

        {data.settings.announcement && (
          <Card className="p-4 rounded-2xl border-amber-300 bg-amber-100/70 flex gap-3" data-testid="today-announcement">
            <Megaphone className="w-5 h-5 text-orange-600 shrink-0 mt-0.5" />
            <div><div className="text-xs font-bold text-orange-700 uppercase">Pengumuman</div><p className="text-sm text-slate-800 whitespace-pre-line">{data.settings.announcement}</p></div>
          </Card>
        )}

        {data.sessions.length === 0 ? (
          <Card className="p-12 rounded-2xl border-amber-100 text-center text-slate-400" data-testid="today-empty">Tidak ada jadwal les hari ini 🌙</Card>
        ) : (
          <div className="space-y-2">
            {data.sessions.map((s, i) => (
              <Card key={i} data-testid={`today-row-${i}`} className={`p-4 rounded-2xl flex items-center gap-4 ${s.kind === "pengganti" ? "border-violet-200 bg-violet-50/50" : "border-amber-100"}`}>
                <div className="w-9 h-9 rounded-full bg-orange-500 text-white font-display font-bold flex items-center justify-center shrink-0">{i + 1}</div>
                <div className="flex-1 min-w-0"><div className="font-semibold text-slate-900 truncate">{s.name}</div><div className="text-xs text-slate-500">{s.level}{s.kind === "pengganti" && <span className="text-violet-600 ml-1"><Repeat className="w-3 h-3 inline" /> pengganti</span>}</div></div>
                <div className="flex items-center gap-1 font-display font-bold text-orange-600 text-lg"><Clock className="w-4 h-4" />{s.time}</div>
              </Card>
            ))}
          </div>
        )}
        <p className="text-center text-xs text-slate-400">Mohon hadir tepat waktu ya. Sampai jumpa di {data.settings.name}! 📚✨</p>
      </div>
    </div>
  );
}
